export default "__VITE_ASSET__bd2bd2be__"